import { PageNotFoundGuard } from './page-not-found.guard';

export const guards: any[] = [PageNotFoundGuard];

export * from './page-not-found.guard';
